NtechApp.JobFavoriteManager = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerAddJobToFavorites]", function(event) {
            if(!NtechApp.clientSettings.isPersonal) {
                NtechApp.info.on("Only personal accounts can save jobs in favorites.", 2500);
                return;
            }

            var $control = $(event.target).closest("[data-triggerAddJobToFavorites]");
            var jobId = $control.attr("data-jobId");

            if($control.hasClass("lockedButton"))
                return;

            $control.addClass("lockedButton");

            me._toggleFavoriteJob($control, jobId);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobFavoriteManager, {
    _enableControlLoader: function($item) {
        var me = this;

        $item.find("[data-ajaxHide]").css("display", "none");

        $item.attr("data-ajaxLoaderOriginalText", $item.text());
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));
    },

    _disableControlLoader: function($item) {
        var me = this;

        $item.find("[data-ajaxHide]").css("display", "inline-block");
        $item.removeClass("lockedButton");

        me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
        $item.find("[data-ajaxLoaderText]").text($item.attr("data-ajaxLoaderOriginalText"));
    },

    _toggleFavoriteJob: function($control, jobId) {
        var me = this;
        me._enableControlLoader($control);

        var params = {
            jobId: jobId
        };
        
        me._ajax.post({
            url: Routing.generate("personal_toggle_save_job_favorite"),
            data: params,
            onSuccess: function(data) {
                if(data.wasSaved) {
                    var controlText = "Remove Favorite";
                    var msg = "Job offer successfully saved in job favorites.";

                    $control.addClass("selectedFavoriteControl");
                }
                else if(data.wasRemoved) {
                    var controlText = "Add to Favorites";
                    var msg = "Job offer successfully removed from job favorites.";

                    $control.removeClass("selectedFavoriteControl");
                }

                $control.find(".controlText").text(controlText);
                NtechApp.info.on(msg, 2500);
            },
            onComplete: function() {
                me._disableControlLoader($control);
            }
        });
    }
});